<ng-container *transloco="let t">
  @if (uploadingFiles?.length) {
    <div class="flex flex-col gap-2">
      @for (uploadingFile of uploadingFiles; track uploadingFile.id) {
        <div appearance="outline" class="min-w-0 text-sm" tuiCardLarge>
          <div class="flex w-full items-center justify-between gap-4">
            <div class="flex min-w-0 items-center justify-start">
              <pxc-file-icon class="max-h-10 min-h-10 min-w-10 max-w-10" [filename]="uploadingFile.file.name" />
              <div class="mx-4 flex min-w-0 grow flex-col justify-evenly">
                <span class="font-bold wrap-break-word">
                  {{ uploadingFile.file.name }}
                </span>
                <span>
                  {{ uploadingFile.file.size | fileSize }}
                </span>
              </div>
            </div>
            @switch (uploadingFile.uploadState) {
              @case (ActionStatus.IN_PROGRESS) {
                <pxc-spinner />
              }
              @case (ActionStatus.SUCCESS) {
                <tui-icon class="text-text-success-primary" icon="@tui.check" />
              }
            }
          </div>
          @if (uploadingFile.uploadState === ActionStatus.ERROR) {
            <div class="flex items-center gap-2">
              <div class="flex items-center gap-1">
                <tui-icon class="text-text-error-primary" icon="@tui.x" />
                <span class="text-text-error-primary">
                  @switch (uploadingFile.errorCode) {
                    @case (HttpCustomErrorCode.FILENAME_TOO_LONG) {
                      {{ t('Le nom du fichier est trop long.') }}
                    }
                    @default {
                      {{ t('Erreur') }}
                    }
                  }
                </span>
              </div>
              @if (isRetryable(uploadingFile.errorCode)) {
                <button
                  appearance="outline"
                  iconStart="@tui.refresh-cw"
                  size="s"
                  tuiButton
                  type="button"
                  (click)="retry(uploadingFile)">
                  {{ t('Réessayer') }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</ng-container>
